export const handleEventSearch = (event) => {
  try {
    const { action, label, value } = event;
    if (!action || !label) {
      throw new Error(`handling unknown event ${JSON.stringify(event)}`);
    }
    var dataLayerEvent = {
      event: "beonly",
      eventAction: action,
      eventLabel: label,
      eventValue: value,
      eventCategory: "beon-search",
    };
    (window.dataLayer || []).push(dataLayerEvent);

    return dataLayerEvent;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const handleEventSearchTerm = ({ action, term, resultsCount }) => {
  const dataEvent = {
    action,
    label: term,
    value: resultsCount,
  };
  return handleEventSearch(dataEvent);
};

export const handleEventSearchProductClick = ({ term, item }) => {
  try {
    const ga4event = {
      event: "beonly",
      eventAction: "hit",
      eventCategory: "beonly-search",
      eventLabel: term,
      eventValue: `${item?.name} (${item?.sku})`,
      productName: item?.name,
      productId: item?.product_id,
      sku: item?.sku,
    };

    (window.dataLayer || []).push(ga4event);
  } catch (e) {
    console.warn("[Bnly] Sending GA4 hit event failed with", e);
  }
};

export const debounceAction = (fn, wait) => {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), wait);
  };
};
